import { useLocalStorage } from '@uidotdev/usehooks';
import {
  BOARD_CARD_VISIBLE_FIELDS_STORAGE_KEY,
  DEFAULT_BOARD_CARD_VISIBLE_FIELDS,
  type BoardCardFieldKey,
} from '../constants';

export type BoardCardVisibleFields = Record<BoardCardFieldKey, boolean>;

export default function useBoardCardVisibleFields() {
  const [storedFields, setStoredFields] = useLocalStorage<Partial<BoardCardVisibleFields>>(
    BOARD_CARD_VISIBLE_FIELDS_STORAGE_KEY,
    DEFAULT_BOARD_CARD_VISIBLE_FIELDS
  );

  // 項目追加後も既存ユーザーの保存値で欠けたキーが undefined にならないよう既定値で補完する
  const visibleFields: BoardCardVisibleFields = {
    ...DEFAULT_BOARD_CARD_VISIBLE_FIELDS,
    ...storedFields,
  };

  const setFieldVisibility = (key: BoardCardFieldKey, visible: boolean) => {
    setStoredFields({ ...visibleFields, [key]: visible });
  };

  return { visibleFields, setFieldVisibility };
}
